import i18next from "../../../../i18n";

i18next.addResources("en", "ThemeMultiSelect", {
    placeholder: "Theme",
    placeholder_active: "Theme ({{count}})",
    searchbar_placeholder: "search",
    reset: "Reset filters",
    reset_label: "Reset",
});
i18next.addResources("fr", "ThemeMultiSelect", {
    placeholder: "Thème",
    placeholder_active: "Thème ({{count}})",
    searchbar_placeholder: "chercher",
    reset: "Réinitialiser les filtres",
    reset_label: "Réinitialiser",
});
